<nav class="navbar navbar-dark sticky-top bg-primary flex-md-nowrap p-0 shadow">
    <a class="navbar-brand col-md-3 col-lg-2 mr-0 px-3" href="#">EPOTTERY</a>
    <button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    
    <ul class="navbar-nav px-3">
      <li class="nav-item text-nowrap">
        <a class="nav-link" href="#">Esci</a>
      </li>
    </ul>
  </nav>
  
  <div class="container-fluid mt-4 h-100">
    <div class="row h-100">
      <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
        <div class="sidebar-sticky pt-3">
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let menuItem of getDashBoardMenu()">
              <a class="nav-link {{menuItem.active? 'font-weight-bold':'font-weight-normal'}}" href="{{menuItem.state}}">
                <span data-feather="home"></span>
                {{menuItem.name}} <span class="sr-only">(current)</span>
              </a>
            </li>
          </ul>
          <hr>
          <h6>Gestione prodotti</h6>
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let menuItem of getProdottiMenu()">
              <a class="nav-link {{menuItem.active? 'font-weight-bold':'font-weight-normal'}}" href="{{menuItem.state}}">
                <span data-feather="home"></span>
                {{menuItem.name}} <span class="sr-only">(current)</span>
              </a>
            </li>
          </ul>
          <hr>
          <h6>Gestione vendite</h6>
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let menuItem of getVenditeMenu()">
              <a class="nav-link {{menuItem.active? 'font-weight-bold':'font-weight-normal'}}" href="{{menuItem.state}}">
                <span data-feather="home"></span>
                {{menuItem.name}} <span class="sr-only">(current)</span>
              </a>
            </li>
          </ul>
          <hr>
          <h6>Gestione sito</h6>
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let menuItem of getOtherMenu()">
              <a class="nav-link {{menuItem.active? 'font-weight-bold':'font-weight-normal'}}" href="{{menuItem.state}}">
                <span data-feather="home"></span>
                {{menuItem.name}} <span class="sr-only">(current)</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-md-4 mt-4">
        <div class="container-fluid mt-1 mb-3">
          <h2>{{titolo??''}}</h2>
          <hr>
        </div>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>


  <ng-template #modalDeleteContent let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Sei sicuro?</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <form>
        <div class="mb-3">
          <p >Sei sicuro di voler eliminare questo elemento?</p>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">No,annulla</button>
      <button type="button" class="btn btn-outline-dark btn-danger" (click)="modalService.deleteYesClick()">Elimina</button>
    </div>
  </ng-template>

  <ng-template #modalContent let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{titleModal}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <form>
        <div class="mb-3">
          <p >{{contentModal}}</p>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button *ngIf="modalYesNo" type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">No</button>
      <button *ngIf="modalYesNo" type="button" class="btn btn-outline-dark btn-danger" (click)="YesClick(yesModalCallback)">Si</button>
      <button *ngIf="!modalYesNo" type="button" class="btn btn-outline-dark btn-danger" (click)="YesClick(yesModalCallback)">Ok</button>
    </div>
  </ng-template>

  <ng-template #modalAggiungiVariante let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{titleModal}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">

        <div class="mb-3">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">Variante</span>
            </div>
            <input type="text" class="form-control" [(ngModel)]="tipologiaVariante" id="basic-url" >
          </div>
        </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Salva</button>
    </div>
  </ng-template>

  <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>